module.exports = __webpack_public_path__ + "img/img43.711c8050.svg";